export abstract class BaseObject
{
  get className(): string {    
      return this.constructor.name;
  }

  // NOTE! Don't remove this. It will break the whole application. 
  set className(className: string) {
  }
}